import { render, staticRenderFns } from "./ModalAddSido.vue?vue&type=template&id=15244339&scoped=true"
import script from "./ModalAddSido.vue?vue&type=script&lang=js"
export * from "./ModalAddSido.vue?vue&type=script&lang=js"
import style0 from "./ModalAddSido.vue?vue&type=style&index=0&id=15244339&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15244339",
  null
  
)

export default component.exports